export const SKILLS = [
    "HTML",
    "CSS",
    "JavaScript",
    "React",
    "Node",
    "Express",
    "MongoDB",
    "Python",
    "Django",
    "Flask",
    "SQL",
    "PostgreSQL",
    "MySQL",
    "Git",
    "GitHub",
    "Heroku",
    "Netlify",
    "Firebase",
    "AWS",
    "Docker",
    "Linux",
    "C",
    "C++",
    "C#",
    "Java",
    "Kotlin",
    "Swift",
    "R",
    "Rust",
    "Go",
    "Scala",
    "PHP",
    "Ruby",
    "Ruby on Rails",
    "Angular",
    "Vue",
    "Bootstrap",
    "Tailwind",
    "Material UI",
    "Sass",
    "Less",
    "jQuery",
    "TypeScript",
    "Next",
    "Gatsby",
    "Jest",
    "Mocha",
    "Chai",
];